import { resetCpanelToastState } from './cpanelToast';

export const CPANEL_TOKEN_KEY = 'token-cpanel';
export const CENTRAL_USER_KEY = 'central-user';
export const CPANEL_LOGIN_PATH = '/cpanel';
const LEGACY_CENTRAL_USER_KEY = 'cpanel-user';

export const getCpanelToken = () => localStorage.getItem(CPANEL_TOKEN_KEY);

export const setCpanelToken = (token) => {
  localStorage.setItem(CPANEL_TOKEN_KEY, token);
};

export const clearCpanelToken = () => {
  localStorage.removeItem(CPANEL_TOKEN_KEY);
};

export const getCentralUser = () => {
  try {
    const raw =
      localStorage.getItem(CENTRAL_USER_KEY) ||
      localStorage.getItem(LEGACY_CENTRAL_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setCentralUser = (user) => {
  if (user) {
    localStorage.setItem(CENTRAL_USER_KEY, JSON.stringify(user));
    localStorage.removeItem(LEGACY_CENTRAL_USER_KEY);
  }
};

export const CPANEL_USER_UPDATED_EVENT = 'cpanel-user-updated';

export const notifyCentralUserUpdated = (user) => {
  if (user) {
    setCentralUser(user);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CPANEL_USER_UPDATED_EVENT, { detail: user || getCentralUser() }));
  }
};

export const clearCentralUser = () => {
  localStorage.removeItem(CENTRAL_USER_KEY);
  localStorage.removeItem(LEGACY_CENTRAL_USER_KEY);
};

export const isCpanelAuthenticated = () => Boolean(getCpanelToken());

export const redirectToCpanelSystem = async (axiosClient) => {
  const { data } = await axiosClient.post('/cpanel/system/sso-code');
  if (!data?.redirectUrl) {
    throw new Error('URL redirect CPanel System tidak tersedia');
  }
  window.location.href = data.redirectUrl;
};

export const fetchCpanelSystemAvailability = async (axiosClient) => {
  try {
    const { data } = await axiosClient.get('/cpanel/system/availability');
    return data?.available === true;
  } catch {
    return false;
  }
};

export const syncCpanelSystemLogout = () => {
  try {
    fetch('/cpanel-system/auth/logout', {
      method: 'GET',
      credentials: 'include',
    }).catch(() => {});
  } catch {
    // ignore
  }
};

export const handleCpanelLogoutQuery = () => {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('cpanel_logout')) return false;

  clearCpanelToken();
  clearCentralUser();
  resetCpanelToastState();

  params.delete('cpanel_logout');
  const next = `${window.location.pathname}${params.toString() ? `?${params}` : ''}`;
  window.history.replaceState({}, '', next);
  return true;
};

export const logoutCpanel = async ({ navigate, hardRedirect = false, axiosClient } = {}) => {
  const token = getCpanelToken();
  if (axiosClient && token) {
    try {
      await axiosClient.post('/cpanel/system/logout');
    } catch {
      // ignore logout API errors
    }
  }

  syncCpanelSystemLogout();
  clearCpanelToken();
  clearCentralUser();
  resetCpanelToastState();

  try {
    document.querySelectorAll('.central-user-menu[data-kt-menu="true"]').forEach((menuEl) => {
      const instance = window.KTMenu?.getInstance?.(menuEl);
      instance?.hide?.();
    });
  } catch {
    // ignore Metronic cleanup errors
  }

  if (hardRedirect || typeof navigate !== 'function') {
    const loginPath = CPANEL_LOGIN_PATH;
    if (window.location.pathname !== loginPath) {
      window.location.replace(loginPath);
    }
    return;
  }

  navigate(CPANEL_LOGIN_PATH, { replace: true });
};

export const getCpanelAssetUrl = (path) => {
  if (!path || typeof path !== 'string') return null;
  const trimmed = path.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const apiBase = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
  const origin = apiBase.replace(/\/api$/i, '') || '';
  const assetPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${origin}${assetPath}`;
};

const CENTRAL_ROLE_LABELS = {
  superadmin: 'Super Admin',
  operator: 'Operator',
};

export const formatCentralRoleLabel = (role) => {
  if (!role || typeof role !== 'string') return null;
  const key = role.trim().toLowerCase();
  return CENTRAL_ROLE_LABELS[key] || role;
};

export const getCentralUserInitials = (user) => {
  const name = (user?.namaLengkap || user?.username || 'A').trim();
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};
